<template>
  <div>
    <div class="content">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size:18px">阀门信息</span>
        </div>
        <div class="text item">
          <div class="left">设备信息</div>
          <div class="right">{{ valveData.deviceName }}</div>
        </div>
        <div class="text item">
          <div class="left">IMEI</div>
          <div class="right">{{ valveData.imei }}</div>
        </div>
        <div class="text item">
          <div class="left">设备地址</div>
          <div class="right">{{ valveData.userAdd }}</div>
        </div>
        <div class="text item">
          <div class="left">在线状态</div>
          <div class="right">{{ valveData.status === 1 ? '开' : '关' }}</div>
        </div>
        <div class="text item">
          <div class="left">口径</div>
          <div class="right">{{ valveData.caliber }}</div>
        </div>
        <!-- <div class="text item">
          <div class="left">阀门开关</div>
          <div class="right">
            <el-switch
              v-model="value"
              @change="change"
              active-text="开"
              inactive-text="关">
            </el-switch>
          </div>
        </div> -->
        <div v-if="value" @click="open" class="switchs open">开</div>
        <div v-else @click="down" class="switchs down">关</div>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Valve",
  data() {
    return {
      valveData: {},
      value: false,
      show: true,
      params: {
        deviceid: "",
        meterAdd: 2303278901,
        operate: 1
      }
    };
  },
  created() {
    this.getValve();
  },
  methods: {
    getValve(){
      const imei = this.$route.query.imei
      axios.get('/api/app/valve/info/' + '861290072099679').then(res=>{
        if(res.data.code === 200){
          this.valveData = res.data.data
          this.value = res.data.data.status === 1 ? false : true;
          this.params.deviceid = res.data.data.deviceId
        }
      })
    },
    change(e){
      if(e){
        this.open();
      }else{
        this.down();
      }
    },
    open() {
				this.params.operate = 1
				this.controlSwitch()
			},
    down() {
      this.params.operate = 2
      this.controlSwitch()
    },
    controlSwitch() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      axios.post('/api/app/valve/operatefm',this.params).then(res=>{
        console.log(res)
        if(res.data.code === 200){
          this.$notify({
            title: '成功',
            message: '操作成功',
            type: 'success'
          });
          this.getValve();
          loading.close();
        }
      })

    },
  }
};
</script>

<style scoped>
.content{
  width: 100%;
  height: 100%;
  padding: 20px 10px;
  box-sizing: border-box;
}
.text {
    font-size: 14px;
  }

  .item {
    width: 100%;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
  }
  .right{
    color: #999;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 100%;
  }
  /deep/ .el-card__header{
    background: #16b981 !important;
    color: #fff !important;
  }
.switchs {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  line-height: 100px;
  font-size: 2rem;
}

.open {
  background: #59d892;
}

.down {
  background: #f87470;
}
/deep/ .el-descriptions-item__cell{
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Valve.vue